// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3mgGa","noInteraction":"EventWrapper_noInteraction__3erpT","pointerPassthrough":"EventWrapper_pointerPassthrough__p__pr"};